import { Component, OnInit,ViewChild } from '@angular/core';
import { CucurachaAdminService } from '../service/cucuracha.service';
import { ExcelService } from '../service/tableUtility.service';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { vendor } from '../models/vendorManagement';
import { ToastrManager } from 'ng6-toastr-notifications';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-vendoraccountmangement',
  templateUrl: './vendoraccountmangement.component.html',
  styleUrls: ['./vendoraccountmangement.component.css']
})
export class VendoraccountmangementComponent implements OnInit {
  dataSource:any
  displayedColumns = ['_id', 'MobileNumber', 'MobileStatus', 'AccountEmailId', 'AccountStatus',
  'firstName', 'lastName','dateOfBirth', 'gender', 'GSTIn','aadharNumber','panNumber','status', 'dateOfCreation', 'kycVerification','Actions']
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  showFilter: boolean=false;
  showCustomisedSearch: boolean=false;
  searchValue: string;
  filterValueSelected: string;
  tableData: [] = [];
  userDetails: any;
  verificationStatus:any;
  confirmText: any;
  showText: string;
  statusValue: boolean;
  constructor(private cs:CucurachaAdminService,private excelService: ExcelService, private toastr: ToastrManager) { }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue.toLowerCase();
    this.dataSource.filter = filterValue;
  }
  applyCustomizedFilterSearch(filterValue: string) {
    filterValue = filterValue.trim();
    filterValue = filterValue;

    if (filterValue != "") {
      this.cs.customizedFilterForVendorsAccounts(this.filterValueSelected, filterValue).subscribe((data) => {
        console.log(data)
        this.dataSource = new MatTableDataSource(data)
        this.dataSource.sort = this.sort
        this.dataSource.paginator = this.paginator

      })
    }
    else {
      this.getAllVendorAccounts()
    }
  }
  filter() {
    this.getAllVendorAccounts()
    if (this.showFilter == false) {
      this.showFilter = true
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""



    }
    else {
      this.showFilter = false
      this.showCustomisedSearch = false
      this.searchValue=""
      this.filterValueSelected=""




    }
  }
  
  applyCustomizedFilter() {
    this.showCustomisedSearch = true
    this.searchValue=""
    this.getAllVendorAccounts();

  }
  onChange(id:any,value:any){
    console.log(value.value)
    if(value.value=='Approved'){
      this.confirmText="Approve",
      this.showText="Are You Sure You Want To Approve?"
    }else{
      this.confirmText="Reject",
      this.showText="Are You Sure you want To Reject?"
    }

    Swal.fire({
      text: this.showText,
      showCancelButton: true,
      confirmButtonText:this.confirmText,
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      allowEscapeKey: false,
      reverseButtons: true,
      cancelButtonColor: '#E1E1E1',
      confirmButtonColor: "#353556",
    }).then((result) => {
      //if user accepted
      if (result.value) {
        this.cs.updateKycStatus(id,value.value).subscribe((data)=>{
          if(data.STATUS_CODE==200){
            this.toastr.successToastr(data.message)
            this.ngOnInit()
          }else{
            this.toastr.errorToastr(data.message)

          }
        })
       
      }
    })

  }
  exportTable() {
    // TableUtil.exportToExcel("Example table",'usersManagement.xlsx');
    this.tableData = (this.dataSource.filteredData)
    console.log(this.tableData)
    this.excelService.exportAsExcelFile(this.tableData, 'VendorAccountManagement');
    this.cs.exportLogAdd(this.userDetails.emailId, 'VendorAccountManagement').subscribe((data) => {
    })
  }
  getAllVendorAccounts(){
    this.cs.getAllVendorAccounts().subscribe((data)=>{
      console.log(data)
      this.dataSource = new MatTableDataSource(data.result)
      this.dataSource.sort = this.sort
      this.dataSource.paginator = this.paginator
    })

  }
  deleteVendorAccount(id:any){
    this.cs.deleteVendorAccount(id).subscribe((data)=>{
      if(data.STATUS_CODE==200){
        this.toastr.successToastr(data.message)
        this.ngOnInit()
      }else{
        this.toastr.errorToastr(data.message)

      }
    })

  }
  onStatusChange(status, id) {
    console.log(status.checked)
    this.statusValue=status.checked
    this.cs.updateVendorAccountStatus(id,this.statusValue).subscribe((data)=>{
      if(data.STATUS_CODE==200){
        this.toastr.successToastr(data.message)
        this.ngOnInit()
      }else{
        this.toastr.errorToastr(data.message)

      }
    })

      
  }
  ngOnInit(): void {
    this.getAllVendorAccounts()
  }

}
